<template>
<div>
  <form @submit.prevent="submit">
    <b-row>
     
      <b-col sm="6">

         <b-form-group label="Ventilación">
          <b-form-input
            type="text"
            :state="$v.boarding.ventilation.$dirty ? !$v.boarding.ventilation.$error : null"
            v-model="$v.boarding.ventilation.$model"
            placeholder="">
            </b-form-input>
            </b-form-group>

              <b-form-group label="Temperatura">
          <b-form-input
            type="text"
            :state="$v.boarding.temperature.$dirty ? !$v.boarding.temperature.$error : null"
            v-model="$v.boarding.temperature.$model"
            placeholder="">
            </b-form-input>
            </b-form-group>

      </b-col>



        <b-col sm="6">
      
         <b-form-group label="Atmósfera">
          <b-form-input
            type="text"
            :state="$v.boarding.atmosphere.$dirty ? !$v.boarding.atmosphere.$error : null"
            v-model="$v.boarding.atmosphere.$model"
            placeholder="">
            </b-form-input>
            </b-form-group>

              <b-form-group label="Gases">
          <b-form-input
            type="text"
            :state="$v.boarding.gas.$dirty ? !$v.boarding.gas.$error : null"
            v-model="$v.boarding.gas.$model"
            placeholder="">
            </b-form-input>
            </b-form-group>

      </b-col> 

      
    </b-row>
  </form>
  </div>
</template>

<script>

  import {required, numeric, minLength, between} from 'vuelidate/lib/validators'

  export default {
    name: "formDatostecnicos",
    props: [
      'boarding'
    ],
    data() {
      return {

      }
    },
    validations: {
      boarding: {
        ventilation: {},
        temperature: {},
        atmosphere: {},
        gas: {},
    
      }
    },
    mounted () {
      this.loadDataForm();
    },
    methods: {
      saveForm(){
       this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
      },
      loadDataForm(){
      
        console.log("");

      },
      submit() {
      },
    },
    beforeMount() {
      
    },
  }

</script>

<style scoped>

</style>
